import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import ButtonComponent from "../../components/ButtonComponent/ButtonComponent";
import EditorComponent from "../../components/EditorComponent/EditorComponent";
import LoaderComponent from "../../components/LoaderComponent/LoaderComponent";
import NotificationComponent from "../../components/NotificationComponent/NotificationComponent";
import { addEditAboutUs, getAboutUs } from "../../services/apiController";

const AboutUs = () => {

    const isAuthenticated = useSelector(state => state.reduxMaster.isAuthenticated);

    const [loading, setLoading] = useState(false);
    // State to manage snackbar visibility and messages
    const [snackbarStates, setSnackbarStates] = useState({ isSnackbarOpen: false, snackbarMessage: '' });
    const handleCloseSnackbar = () => {
        setSnackbarStates({ isSnackbarOpen: false, snackbarMessage: '', snackbarSeverity: '' });
    };

    const [templateBody, setTemplateBody] = useState("");

    useEffect(() => {
        wsGetAboutUs();
    }, []);

    const wsGetAboutUs = () => {
        setLoading(true);

        getAboutUs({})
            .then((response) => {
                setTemplateBody(response.aboutUsDetails);
                setLoading(false);
            }).catch((err) => {
                setLoading(false);
            })
    }

    const handleAddEditAboutUs = (e) => {
        e?.preventDefault();
        if (templateBody == "") {
            setSnackbarStates({ isSnackbarOpen: true, snackbarMessage: "Please Enter About Us Details", snackbarSeverity: 'error' });
        } else {
            addEditAboutUs({ aboutUsDetails: templateBody })
                .then((response) => {
                    if (response.status == 1) {
                        setSnackbarStates({ isSnackbarOpen: true, snackbarMessage: response.message, snackbarSeverity: 'success' });
                    } else {
                        setSnackbarStates({ isSnackbarOpen: true, snackbarMessage: response.message, snackbarSeverity: 'error' });
                    }
                }).catch((error) => {
                    setSnackbarStates({ isSnackbarOpen: true, snackbarMessage: "Something went wrong, Please try again", snackbarSeverity: 'error' });
                    setLoading(false);
                });
        }
    }

    return (loading ? <LoaderComponent />
        : isAuthenticated
            ? (<React.Fragment>
                <NotificationComponent isOpen={snackbarStates.isSnackbarOpen} message={snackbarStates.snackbarMessage} onClose={handleCloseSnackbar} severity={snackbarStates.snackbarSeverity} />

                <div className="booking-container">
                    <p><strong>About Us</strong></p>

                    <EditorComponent height={400} placeholder="About Us Details" value={templateBody} onChange={(value) => setTemplateBody(value)} />

                    <div style={{ textAlign: 'end', marginTop: '2%' }}>
                        <ButtonComponent disabled={loading} onClick={handleAddEditAboutUs}>Update</ButtonComponent>
                    </div>
                </div>
            </React.Fragment>)
            : (<React.Fragment>
                <div style={{ padding: '2% 20%' }}>
                    <p><strong>About Us</strong></p>

                    <div dangerouslySetInnerHTML={{ __html: templateBody }}></div>

                    {/* <p><strong>The Creators</strong></p>
                <p>
                    Akadeet was created by Harshit Shah & Meera Shah. Two Amdavadi dreamers who believed the city needed a space that blended shopping with culture, food with music, and creativity with celebration.<br /><br />

                    Harshit brought the vision for building a truly immersive event something beyond booths and billings while Meera added the intuitive understanding of design, curation and storytelling. Together, they shaped Akadeet into a festival that feels effortless, yet thoughtfully crafted in every corner.<br /><br />

                    They built a tradition. A place Amdavad looks forward to, edition after edition.
                </p> */}
                </div>
            </React.Fragment>)
    );
}

export default AboutUs;